module.exports = __webpack_public_path__ + "static/media/moia_bus.cb24eb29.svg";